/**
 * Post-Render Screen Shake — Sakurai method 2.
 * Offsets the entire canvas via CSS translate for maximum impact.
 * Shakes everything including UI — separate from camera shake.
 */

import { Time } from 'bonkjs';
import { setScreenShakeOffset } from '../viewport';

export class ScreenShake {
  private intensity: number = 0;
  private decay: number = 0.85;

  /** Trigger a post-render shake. Higher intensity = bigger offset (screen pixels). */
  trigger(intensity: number, decay: number = 0.85): void {
    // Take the stronger of current vs new
    this.intensity = Math.max(this.intensity, intensity);
    this.decay = decay;
  }

  update(): void {
    if (this.intensity < 0.5) {
      this.intensity = 0;
      setScreenShakeOffset(0, 0);
      return;
    }

    const ox = (Math.random() - 0.5) * this.intensity * 2;
    const oy = (Math.random() - 0.5) * this.intensity * 2;
    setScreenShakeOffset(ox, oy);

    // Frame-rate independent decay — normalized to 60 FPS
    const dt = Time.deltaTime;
    this.intensity *= Math.pow(this.decay, dt * 60);
  }
}
